import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import ReportAdminView from '../../containers/admin/ReportAdminView'
import APageRow from '../../components/atoms/APageRow'
import { AButton } from '../../components/atoms'
import { IAdmin } from '../../data/admin/customer.interface'


class PReportAdminView extends React.Component<RouteComponentProps> {
    onModify = (row: IAdmin) =>
            `reportusers-modify/${row.email}/modify`
    
    render() {
        const {} = this.props
        return (
             <React.Fragment>
                <APageRow
                    title="Report users"
                    buttons={[
                        <AButton
                            key="create"
                            outline
                            to={`reportusers/create`}
                            color="primary"
                        >
                            Create Report User
                        </AButton>,
                    ]}
                ></APageRow>
        <ReportAdminView  onModify={this.onModify}     />
        </React.Fragment>
            
        )
    }
}

export default PReportAdminView
